import devConfig from './dev'
import qaConfig from './qa'
import stgConfig from './stg'
import prodConfig from './prod'

const ENVS = {
  dev: 'dev',
  qa: 'qa',
  stg: 'stg',
  prod: 'prod',
}

interface IEnv {
  reCaptchaSiteKey: string,
  api: string,
  paymetric: string,
  analytics: {
    account: string,
    profile: string,
    environment: string,
  },
  isDebugInfo: boolean,
}

const getEnvConfig = (env = ENVS.dev): IEnv => {
  const config = devConfig

  if (env === ENVS.qa) {
    return {
      ...config,
      ...qaConfig,
    }
  }

  if (env === ENVS.stg) {
    return {
      ...config,
      ...stgConfig,
    }
  }

  if (env === ENVS.prod) {
    return {
      ...config,
      ...prodConfig,
    }
  }

  return config
}

export default getEnvConfig(window.env)
